import { Controller } from "@hotwired/stimulus"

// 入力値の空 / 非空に応じて、 親 <td> の bg-rose-50 クラスを付け外しする。
// - text_field / select ( 要素自身が入力 ) の場合: controller を input に置く
// - datetime のように子要素 ( hidden ) を値の source にする場合は controller を wrapper に、
//   hidden に target: "input" を指定する
export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.toggle()
  }

  toggle() {
    const source = this.hasInputTarget ? this.inputTarget : this.element
    const value = (source.value || "").trim()
    const cell = this.element.closest("td")
    if (cell) cell.classList.toggle("bg-rose-50", value.length === 0)
  }
}
